export default {
  selectLang: "选择语言",
  footer: {
    copyright: "© 2025 TaxEcoBit. 版权所有。",
    terms: "服务条款",
    privacy: "隐私政策",
    help: "需要帮助或建议？",
  },
  menu: {
    dashboard: "仪表板",
    calculate: "计算",
    calculations: "计算记录",
    pricing: "价格",
    settings: "设置",
    factors: "因子",
    reports: "报告",
    upgrade: "升级",
    community: "社区",
    usage: "使用情况",
    invite: "邀请",
    home: "首页",
    blog: "博客",
    whitepaper: "白皮书",
    about: "关于我们",
    faq: "常见问题",
    terms: "服务条款",
    privacy: "隐私政策",
    tickets: "工单",
    billing: "账单",
    "billing-overview": "概览",
    "billing-orders": "订单",
    "billing-invoices": "发票",
    "billing-subscription": "订阅",
    templates: "模板",
  },
  upgradeWall: {
    successTitle: "试用申请成功",
    successSubtitle: "您已成功申请14天免费高级套餐试用",
    quotaTitle: "计算配额：",
    reportQuotaTitle: "报告配额：",
    planComparison: "套餐功能对比",
    calculation: "计算",
    report: "报告",
    price: "价格",
    viewPricing: "查看完整价格",
    freeTrial: "14天免费高级套餐试用",
    upgradeToPro: "升级到高级版",
    upgradePro: "升级专业版",
    contactSupport: "联系支持",
    inviteRewards: "通过邀请获得更多配额！",
    inviteRewardsDesc: "邀请朋友注册，您和您的朋友都将获得额外的计算配额",
    inviteFriends: "邀请朋友",
    quotaExhausted: "您的套餐配额已用完",
    calculationThreshold: "您的计算配额已使用 {percent}%",
    reportThreshold: "您的报告配额已使用 {percent}%",
    upgradePlan: "升级您的套餐",
    free: "免费",
    basic: "€49/月",
    proPrice: "€99/月",
    timesPerMonth: "次/月",
    plan: "套餐",
    trialSuccess: "试用申请成功",
  },
  ticket: {
    modal_title: "提交工单",
  },
  brand: {
    what_is_taxecobit: "什么是TaxEcoBit？",
    taxecobit_description:
      "TaxEcoBit是一个为受欧盟碳边境调节机制(CBAM)影响的企业构建的合规自动化平台。我们帮助进口商、制造商和中小企业计算产品级碳排放，生成CBAM合规报告，并降低监管风险。",
    taxecobit_benefits: "使用TaxEcoBit，用户可以：",
    benefit_accurate_calculations: "使用官方和自定义排放因子进行精确的碳计算",
    benefit_cbam_documents: "生成可直接提交的CBAM文档",
    benefit_carbon_cost_tracking: "监控碳成本影响并优化运营效率",
    benefit_api_integration: "通过API与ERP和供应链系统无缝集成合规工作流程",
    taxecobit_conclusion:
      "通过替代手工电子表格和咨询依赖，TaxEcoBit以更低的运营成本实现更快、更可靠的合规。",
  },
  userLevel: {
    label: "用户等级",
    highest_level: "最高等级",
    next_level: "下一等级: {level}",
    standard_user: "标准用户",
    bronze_user: "青铜用户",
    silver_user: "白银用户",
    gold_user: "黄金用户",
    platinum_user: "铂金用户",
    bronze_next: "青铜 (50次计算)",
    silver_next: "白银 (150次计算)",
    gold_next: "黄金 (300次计算)",
    platinum_next: "铂金 (600次计算)",
    highest_level_text: "已达到最高等级",
  },
  notification: {
    title: "通知",
    settings: "通知设置",
    preferences: "通知偏好",
    email_notifications: "邮件通知",
    app_notifications: "应用通知",
    all: "所有通知",
    important: "仅重要通知",
    none: "无通知",
    save_preferences: "保存通知偏好",
    success_message: "通知偏好保存成功",
    error_message: "保存通知偏好失败",
    detail_title: "通知详情",
    mark_as_read: "标记为已读",
    not_found_title: "通知未找到",
    not_found_desc: "您查找的通知不存在或已被删除。",
    search_placeholder: "按标题或内容搜索",
    email_sent: "邮件已发送",
    in_app_only: "仅应用内",
    no_notifications: "暂无通知",
    total: "共 {total} 条通知",
    fetch_failed: "获取通知失败",
    marked_as_read: "标记为已读成功",
    mark_failed: "标记为已读失败",
    mark_all_read: "全部标记为已读",
    view_all: "查看全部",
  },
  notFound: {
    title: "404 页面未找到",
    description: "抱歉，您访问的页面不存在。",
    goHome: "返回首页",
  },
  login: {
    sign_in: "登录",
    sign_up: "注册",
    password_rule_length: "至少8个字符",
    password_rule_letter: "包含英文字母",
    password_rule_number: "包含数字",
    password_rule_special: "包含特殊字符 {0}",
  },
};
